import './dashboard-ad-modal-content.scss';

type DashboardAdContentPropsTypes = {
  link: string;
};

const DashboardAdModalContent = (props: DashboardAdContentPropsTypes) => {
  return (
    <>
      <div className="dashboard-ad-modal-content">
        <video controls autoPlay={true}>
          <source src={props.link} type="video/mp4" />
        </video>
      </div>
    </>
  );
};

export default DashboardAdModalContent;
